module.exports = __webpack_public_path__ + "img/Bear23.bd14a95a.jpg";